import React from "react";
import SvgWave from './SvgWave';
import Select from './DisplaySelect';
import SpeedSelect from './DisplaySpeedSelect';
import { useRecoilState } from "recoil";
import { selectBedInfoState } from '../../plugins/recoil';

import { Draggable } from '@hello-pangea/dnd';

//Wave 표기
function DisPlayWave({index,wave,handleChangeSelect, handleChangeSpeedSelect, waveList,waveCodeList}) {    
    const [selectBedInfo, ] = useRecoilState(selectBedInfoState) 
    return (        
        <Draggable draggableId={`draggable-${selectBedInfo.deviceId}-${wave.measureParameterId}-${wave.displayOrder}`} index={index}>
            {
                (provided) => (
                    <div className="relative" ref={provided.innerRef} {...provided.draggableProps} {...provided.dragHandleProps}>
                        <SvgWave value={wave.measureParameter} style={'border-b-[1px] border-[#4E4E4E] box-content'}/>
                        <div className="absolute flex items-center top-[4px] left-[4px] gap-[8px]">
                            <Select options={waveCodeList} value={wave.measureParameterId} index={index} selectType={'Wave'} list={waveList} handleChangeSelect={handleChangeSelect}/>
                            {
                                wave.measureParameter !== 'NONE' &&
                                <SpeedSelect waveType={wave.measureParameter} index={index} handleChangeSelect={handleChangeSpeedSelect}/>
                            }
                        </div>
                    </div>
                )
            }            
        </Draggable>        
    );
}

export default DisPlayWave;
